import React from "react";
import ReactDom from "react-dom";
import Search from "./Search.jsx";

export default function renderSearch() {
  document.querySelectorAll(".js-search-mount").forEach((mount) => {
    const dictionary = JSON.parse(mount.dataset.dictionary) || null;
    const query = JSON.parse(mount.dataset.query) || {};
    const dataModel = JSON.parse(mount.dataset.model);
    const showQueryStrings =
      dataModel.enableQueryString &&
      !document.querySelector("body.is-page-editor");

    ReactDom.render(
      <Search
        dictionary={dictionary}
        query={query}
        {...dataModel}
        enableQueryString={showQueryStrings}
      />,
      mount,
    );
  });
}
